import styled, { css } from 'styled-components'

const Container = styled.aside`
  outline: none;
  background-color: ${props => props.theme.color.monochrome.lighter};
  position: fixed;
  z-index: 75;
  top: -100%;
  left: 0;
  right: 0;
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.color.monochrome.light};
  transition: top 0.5s ease-in-out;

  ${props =>
    !props.inView &&
    css`
      top: 0;
    `}
`

export default Container
